import { Loader2 } from "lucide-react";

export function Loading({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-24 text-slate-500">
      <Loader2 className="w-6 h-6 animate-spin mr-2" />
      <span className="uppercase tracking-widest text-sm font-bold">{label}</span>
    </div>
  );
}

export function StatTile({ label, value, accent, testid }) {
  return (
    <div data-testid={testid} className="panel rounded-sm p-4">
      <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">
        {label}
      </div>
      <div
        className={`font-display text-3xl md:text-4xl font-extrabold leading-none mt-1 ${
          accent || "text-white"
        }`}
      >
        {value}
      </div>
    </div>
  );
}

export function StreakBadge({ streak, className = "" }) {
  if (!streak || !streak.type || streak.count === 0)
    return <span className={`text-slate-500 font-bold ${className}`}>—</span>;
  const win = streak.type === "W";
  return (
    <span
      className={`font-display font-extrabold ${
        win ? "text-[#FFCC00]" : "text-[#FF3B30]"
      } ${className}`}
    >
      {streak.type}
      {streak.count}
    </span>
  );
}

export function initials(name) {
  return (name || "?")
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function Avatar({ name, size = 40, active }) {
  const colors = ["#007AFF", "#FF3B30", "#FFCC00", "#34C759", "#AF52DE", "#FF9500"];
  const idx = (name || "").charCodeAt(0) % colors.length;
  return (
    <div
      className="flex items-center justify-center font-display font-extrabold rounded-sm text-black shrink-0"
      style={{
        width: size,
        height: size,
        backgroundColor: colors[idx] || "#007AFF",
        fontSize: size * 0.42,
        outline: active ? "2px solid #fff" : "none",
      }}
    >
      {initials(name)}
    </div>
  );
}
